export default "__VITE_ASSET__B1w6rngv__"